import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'
import { InvoiceEditorConfigurableElement } from '../../types/invoiceEditorConfigurableElement'
import { InvoiceEditorElementRestriction } from '../../types/invoiceEditorElementRestriction'

type InvoiceEditorVariantConfig = Partial<Record<InvoiceEditorConfigurableElement, InvoiceEditorElementRestriction>> & {
  invoiceLineColumns?: {
    restriction: InvoiceEditorElementRestriction
    except?: InvoiceLineColumn[]
  }
}

const depositInvoiceRestrictions: InvoiceEditorVariantConfig = {
  columnVisibilityButton: 'hidden',
  dateOfSaleOrService: 'hidden',
  issuer: 'disabled',
  receiver: 'disabled',
}

const finalInvoiceRestrictions: InvoiceEditorVariantConfig = {
  columnVisibilityButton: 'hidden',
  invoiceLineColumns: { restriction: 'disabled' },
  issuer: 'disabled',
  receiver: 'disabled',
}

export const invoiceEditorElementRestrictionsByVariant: Partial<
  Record<InvoiceEditorVariant, InvoiceEditorVariantConfig>
> = {
  [InvoiceEditorVariant.CreditNoteFromInvoice]: {
    dateOfSaleOrService: 'disabled',
    discount: 'disabled',
    invoiceLineColumns: { restriction: 'disabled', except: ['unitPrice'] },
    issuer: 'disabled',
    receiver: 'disabled',
    saveAsDraftButton: 'hidden',
  },
  [InvoiceEditorVariant.DepositInvoiceDraftEdit]: depositInvoiceRestrictions,
  [InvoiceEditorVariant.DepositInvoiceNewFromQuote]: depositInvoiceRestrictions,
  [InvoiceEditorVariant.FinalInvoiceDraftEdit]: finalInvoiceRestrictions,
  [InvoiceEditorVariant.FinalInvoiceNewFromQuote]: finalInvoiceRestrictions,
  [InvoiceEditorVariant.QuoteEdit]: {
    invoiceNumber: 'hidden',
    saveAsDraftButton: 'hidden',
  },
}
